export default __webpack_public_path__ + "static/media/bg-15.0ccab2d5.jpg";